import React from 'react';

// Utiliser la classe w-full h-full pour que les icônes s'adaptent à leur conteneur
const iconStyle = "w-full h-full"; // Style par défaut pour les icônes dans les catégories

export const IconComponents = {
  ServerBoostIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M7.41 14.41L12 9.83l4.59 4.58L18 13l-6-6-6 6 1.41 1.41z"/>
      <path d="M7.41 19.41L12 14.83l4.59 4.58L18 18l-6-6-6 6 1.41 1.41z"/>
    </svg>
  ),
  StarIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  ),
  RocketIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.45 16h2.09L9.43 3.62a.748.748 0 00-1.39.31l-.85 4.25L3.42 9.34a.75.75 0 00-.31 1.39L16 15.84V13.7l-3.55-1.85z M6.5 12.27l2.99-.82.84-4.11 3.68 9.16-7.51-4.23zm13.49 7.29A7.969 7.969 0 0021 15.5c0-2.97-1.61-5.57-4-6.96V3.69c0-.61-.36-1.16-.91-1.39a1.49 1.49 0 00-1.57.23l-2.44 2.02A7.936 7.936 0 009 4c-1.29 0-2.5.31-3.57.85L2.99 2.83a1.49 1.49 0 00-1.57-.23c-.55.23-.91.78-.91 1.39v4.85c-2.39 1.39-4 3.99-4 6.96 0 2.38.95 4.53 2.49 6.11L1.41 23.5l1.41 1.41 1.59-1.59c1.86 1.05 4 1.68 6.29 1.68 2.29 0 4.43-.63 6.29-1.68l1.59 1.59 1.41-1.41-1.41-1.41zM5 15.5C5 11.91 7.91 9 11.5 9s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5S5 19.09 5 15.5z"/>
    </svg>
  ),
  BoltIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"/>
    </svg>
  ),
  UsersIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor" stroke="currentColor">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
    </svg>
  ),
  ChatIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
    </svg>
  ),
  HeartIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
  ),
  FireIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 23c-4.41 0-8-3.59-8-8 0-3.31 2.73-7.82 5.6-11.93a1 1 0 0 1 1.65-.08c2.97 4.02 5.75 8.43 5.75 12.01 0 4.41-3.59 8-8 8zm0-17.93c-2.37 3.45-4 6.89-4 9.93 0 2.21 1.79 4 4 4s4-1.79 4-4c0-2.86-1.78-6.34-4-9.93z"/>
    </svg>
  ),
  DiamondIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.16 3l-2.91 2.91 7.65 7.65 2.91-2.91zM3.57 11.57l7.65 7.65 2.91-2.91-7.65-7.65zM19.07 3l-2.91 2.91 1.42 1.42 2.91-2.91zM3 19.07l2.91-2.91-1.42-1.42-2.91 2.91z"/>
    </svg>
  ),
  CrownIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 8l3.59 3.59 2.83-2.83 1.41 1.41L12 18 4.17 10.17l1.41-1.41 2.83 2.83z"/>
    </svg>
  ),
  ShieldIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
    </svg>
  ),
  SparklesIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M5 3v4M3 5h4m-1 12v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
    </svg>
  ),
  ToolsIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
    </svg>
  ),
  GiftIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm9 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
    </svg>
  ),
  MusicIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
    </svg>
  ),
  GamepadIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"/>
    </svg>
  ),
  CartIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 3h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020.01 4H5.21l-.67-1.43a.998.998 0 00-.9-.57H1c-.55 0-1 .45-1 1s.45 1 1 1zm16 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
    </svg>
  ),
  MoneyIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
    </svg>
  ),
  BellIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"/>
    </svg>
  ),
  TrophyIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/>
    </svg>
  ),
  HashtagIcon: () => (
    <svg className={iconStyle} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4zm-6 4h-4v-4h4v4z"/>
    </svg>
  )
};

export const iconNames = Object.keys(IconComponents);

export default IconComponents; 